module.exports = __webpack_public_path__ + "img/empty_profile.014612e6.svg";